export const extractBaseDomain = (urlString: string): string | null => {
  try {
    const url = new URL(urlString)
    const hostname = url?.hostname?.replace(/^www\./, '')
    const parts = hostname?.split('.')

    if (parts?.length >= 2) {
      return parts[parts.length - 2]
    }

    return hostname
  } catch (e) {
    return ''
  }
}
